import {
    CLOSE_CLAIM,
    GENERATE_CLAIM,
    GET_CLAIMS,
    GET_CLAIM_BY_ID,
    SUBMIT_CLAIM,
    GET_BILL_INVOICE_PAYMENT,
    GET_BILL_CLAIM_PAYMENT_TRANSACTIONS,
    GET_SUBMITTED_CLAIMS,
    GET_CLAIM_BATCHES,
    GET_CLAIM_BATCH_BY_ID,
    SUBMIT_CLAIM_BY_ID,
    REFRESH_CLAIM,
    RESUBMIT_CLAIM,
    EDIT_CLAIM,
    REMOVE_APPT_FROM_CLAIM,
    DELETE_CLAIM,
    GET_BILLING_OVERVIEW,
    GET_CLAIM_AGING,
    RE_SUBMIT_CLAIM,
    GET_PENDING_CLAIMS_TOTAL,
    GET_BILLABLE_CLAIMS_TOTAL,
    CHANGE_CLAIM_STATUS,
    GET_COMPLETE_CLAIM_TOTALS,
    APPEAL_SUBMITTED_CLAIM,
    MARK_AS_SECONDARY_BILLING,
    CANCEL_CLAIM,
    MARK_AS_READY_SECONDARY_BILLING,
    EDIT_READY_SECONDARY_BILLING,
    REFRESH_APPT_UNITS,
    CHECK_CLAIM_STATUS,
    UPDATE_BILL_ADJUSTMENTS,
} from './claim.type';

export const getPendingClaims = (data, load) => {
    return {
        type: GET_CLAIMS,
        payload: { data, load },
    };
};
export const getPendingClaimsTotal = (data, load) => {
    return {
        type: GET_PENDING_CLAIMS_TOTAL,
        payload: { data, load },
    };
};
export const getBillableClaimsTotal = (data, load) => {
    return {
        type: GET_BILLABLE_CLAIMS_TOTAL,
        payload: { data, load },
    };
};
export const getClaimAging = (data, load) => {
    return {
        type: GET_CLAIM_AGING,
        payload: { data, load },
    };
};

export const getCompletedClaimTotals = (data) => {
    return {
        type: GET_COMPLETE_CLAIM_TOTALS,
        payload: { data },
    };
};

export const getSubmittedClaims = (data, load) => {
    return {
        type: GET_SUBMITTED_CLAIMS,
        payload: { data, load },
    };
};

/** Submitted claim batches for the Batch View — GET /claim/batch */
export const getClaimBatches = (data, load) => {
    return {
        type: GET_CLAIM_BATCHES,
        payload: { data, load },
    };
};

/** Single batch with populated claims (accordion expand) — GET /claim/batch/:id */
export const getClaimBatchById = (id, load) => {
    return {
        type: GET_CLAIM_BATCH_BY_ID,
        payload: { id, load },
    };
};

export const getClaimById = (id, load) => {
    return {
        type: GET_CLAIM_BY_ID,
        payload: { id, load },
    };
};

export const generateClaim = (body, params) => {
    return {
        type: GENERATE_CLAIM,
        payload: { body, params },
    };
};

export const editClaim = (id, body) => {
    return {
        type: EDIT_CLAIM,
        payload: { id, body },
    };
};

export const deleteClaim = (params) => {
    return {
        type: DELETE_CLAIM,
        payload: { params },
    };
};
export const changeClaimStatus = (params, singleId) => {
    return {
        type: CHANGE_CLAIM_STATUS,
        payload: { params, singleId },
    };
};
export const appealSubmittedClaim = (params, renderParams, claimId) => {
    return {
        type: APPEAL_SUBMITTED_CLAIM,
        payload: { params, renderParams, claimId },
    };
};

/**Claim Status Actions */

export const checkClaimStatus = (params, claimId) => {
    return {
        type: CHECK_CLAIM_STATUS,
        payload: { params, claimId },
    };
};

export const cancelClaim = (params, claimId) => {
    return {
        type: CANCEL_CLAIM,
        payload: { params, claimId },
    };
};
export const closeClaim = (id, details) => {
    return {
        type: CLOSE_CLAIM,
        payload: { id, details },
    };
};

export const submitClaim = (id, requestParams, type) => {
    return {
        type: SUBMIT_CLAIM,
        payload: { id, requestParams, type },
    };
};

export const reSubmitClaim = (ids) => {
    return {
        type: RE_SUBMIT_CLAIM,
        payload: { ids },
    };
};

export const submitClaimById = (id) => {
    return {
        type: SUBMIT_CLAIM_BY_ID,
        payload: { id },
    };
};

export const refreshClaim = (id) => {
    return {
        type: REFRESH_CLAIM,
        payload: { id },
    };
};

export const resubmitClaim = (id) => {
    return {
        type: RESUBMIT_CLAIM,
        payload: { id },
    };
};

export const removeFromClaim = (data, claimId, status) => {
    return {
        type: REMOVE_APPT_FROM_CLAIM,
        payload: { data, claimId, status },
    };
};

/**Bill Details */

export const bilClaimPmtTr = (id) => {
    return {
        type: GET_BILL_CLAIM_PAYMENT_TRANSACTIONS,
        payload: { id },
    };
};

export const bilInvoicePmt = (ids) => {
    return {
        type: GET_BILL_INVOICE_PAYMENT,
        payload: { ids },
    };
};

/** Overview */
export const getBillingOverview = (params, load) => {
    return {
        type: GET_BILLING_OVERVIEW,
        payload: { params, load },
    };
};

/** End */

export const markAsSecondaryBilling = (claimId, params) => {
    return {
        type: MARK_AS_SECONDARY_BILLING,
        payload: { claimId, params },
    };
};
export const markAsReadySecondaryBilling = (claimId, body) => {
    return {
        type: MARK_AS_READY_SECONDARY_BILLING,
        payload: { claimId, body },
    };
};
export const editReadySecondaryBilling = (claimId, body) => {
    return {
        type: EDIT_READY_SECONDARY_BILLING,
        payload: { claimId, body },
    };
};

export const refreshApptUnits = (apptId, claimId) => {
    return {
        type: REFRESH_APPT_UNITS,
        payload: { apptId, claimId },
    };
};

/** Bill Adjustments (CAS) */
export const updateBillAdjustments = (claimId, billId, adjustments) => {
    return {
        type: UPDATE_BILL_ADJUSTMENTS,
        payload: { claimId, billId, adjustments },
    };
};
